export const MAX_PRICE_AVALIABLE_VALUE = 999_999_999_999;